import React from 'react';
import type { FormHTMLAttributes } from 'react';
import classNames from 'classnames';

export interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  variant?: 'default' | 'large';
}

/**
 * The Form Component based on [The USWDS Form component](https://designsystem.digital.gov/components/form-controls/)
 */
const Form = ({ children, className, variant = 'default', ...rest }: FormProps): JSX.Element => {
  return (
    <form
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      className={classNames('usa-form', className, {
        'usa-form--large': variant === 'large',
      })}
    >
      {children}
    </form>
  );
};

export default Form;
